import {type PaletteColor, type PaletteOptions} from '@mui/material/styles';

export const LearnerPortalPrimaryColor: PaletteColor = {
  light: '#F7B27A',
  main: '#f26722',
  dark: '#B93815',
  contrastText: '#fff',
};

export const ThemeLearnerPortalPalette: PaletteOptions = {
  primary: LearnerPortalPrimaryColor,
};
